var map = {
	"./air-conditioner.svg": "2f64",
	"./bathroom.svg": "850c",
	"./bed.svg": "f035",
	"./cctv.svg": "838e",
	"./desk.svg": "0d99",
	"./drinking-water.svg": "b43d",
	"./electric-generator.svg": "af67",
	"./gym.svg": "96f6",
	"./house-keeping.svg": "3783",
	"./lift.svg": "6c8f",
	"./parking.svg": "7346",
	"./plate.svg": "2171",
	"./room-sharing.svg": "2200",
	"./security.svg": "5f0d",
	"./shower.svg": "9d0e",
	"./tv.svg": "e678",
	"./wardrobe.svg": "5f47",
	"./washing-machine.svg": "8378",
	"./water-heater.svg": "309a",
	"./wifi.svg": "4351"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";